// extracted by mini-css-extract-plugin
export default {"lessons":"Lessons_lessons__pZoMW","section":"Lessons_section__8MyIG","itemsContainer":"Lessons_itemsContainer__6Za8J","title":"Lessons_title__vpsqN"};